// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Space+Grotesk:wght@500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f0f7 100%);
  min-height: 100vh;
}

.App {
  min-height: 100vh;
}

/* UNIVERSAL AUTO-CAPITALIZE - All text inputs convert to UPPERCASE */
input[type="text"]:not(.no-uppercase):not([type="email"]):not([type="url"]),
input:not([type]):not(.no-uppercase),
textarea:not(.no-uppercase) {
  text-transform: uppercase !important;
}

/* Exceptions - Do NOT capitalize these */
input[type="email"],
input[type="url"],
input[type="password"],
input[type="number"],
input[type="date"],
input[type="time"],
input[type="search"].no-uppercase,
input.no-uppercase,
textarea.no-uppercase {
  text-transform: none !important;
}

/* Login Page */
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0066cc 0%, #004d99 50%, #003366 100%);
  padding: 20px;
  padding-bottom: 60px; /* Space for footer */
}

.login-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 48px;
  max-width: 440px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-logo {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #0066cc, #0052a3);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 32px;
  color: white;
  font-weight: 700;
  font-family: 'Space Grotesk', sans-serif;
}

.login-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  font-family: 'Space Grotesk', sans-serif;
}

.login-subtitle {
  color: #666;
  font-size: 15px;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
}

.form-input:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 4px rgba(0, 102, 204, 0.1);
}

.btn-primary {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #0066cc, #0052a3);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 102, 204, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.otp-note {
  margin-top: 16px;
  padding: 12px;
  background: #eff6ff;
  border-left: 3px solid #0066cc;
  border-radius: 8px;
  font-size: 13px;
  color: #0066cc;
}

/* Dashboard Layout */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 70px;
  background: linear-gradient(180deg, #0066cc 0%, #004d99 100%);
  color: white;
  padding: 16px 0;
  padding-bottom: 100px;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
  transition: width 0.3s ease;
}

.sidebar:hover {
  width: 260px;
}

.sidebar-text {
  opacity: 0;
  width: 0;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.sidebar:hover .sidebar-text {
  opacity: 1;
  width: auto;
  min-width: max-content;
}

.sidebar-header {
  padding: 0 0 16px 0;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar:hover .sidebar-header {
  padding: 0 20px 16px 20px;
  justify-content: flex-start;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
  font-family: 'Space Grotesk', sans-serif;
}

.sidebar-logo-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-menu {
  padding: 12px 0;
  margin-bottom: 80px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin: 2px 0;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
  justify-content: center;
  white-space: nowrap;
}

.sidebar:hover .menu-item {
  justify-content: flex-start;
  padding: 10px 20px;
}

.menu-item:hover,
.menu-item.active {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border-left: 3px solid white;
}

/* Menu Groups */
.menu-group {
  margin-bottom: 4px;
}

.menu-group-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  margin: 2px 0;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 14px;
  justify-content: center;
  white-space: nowrap;
}

.sidebar:hover .menu-group-header {
  justify-content: flex-start;
  padding: 8px 20px;
}

.menu-group-header:hover {
  background: rgba(255, 255, 255, 0.1);
}

.menu-group-items {
  display: flex;
  flex-direction: column;
}

.menu-subitem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  padding-left: 28px;
  margin: 1px 0;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 400;
  font-size: 13px;
  justify-content: center;
  white-space: nowrap;
  min-width: 0;
}

.sidebar:hover .menu-subitem {
  justify-content: flex-start;
  padding-left: 44px;
  padding-right: 20px;
  overflow: visible;
}

.sidebar:hover .menu-subitem .sidebar-text {
  overflow: visible;
  text-overflow: clip;
}

.menu-subitem:hover,
.menu-subitem.active {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-left: 3px solid rgba(255, 255, 255, 0.5);
}

.sidebar-footer {
  position: fixed;
  bottom: 0;
  width: 70px;
  padding: 12px 12px;
  background: linear-gradient(180deg, #004d99 0%, #003366 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  transition: width 0.3s ease;
}

.sidebar:hover .sidebar-footer {
  width: 260px;
  padding: 16px 20px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  justify-content: center;
}

.sidebar:hover .user-info {
  justify-content: flex-start;
}

.user-avatar {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.user-details {
  flex: 1 1;
}

.user-name {
  font-weight: 600;
  font-size: 14px;
}

.user-role {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  text-transform: capitalize;
}

.btn-logout {
  width: 100%;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar:not(:hover) .btn-logout {

/* Remove number input arrows - Force override */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}

input[type=number] {
  -moz-appearance: textfield !important;
}

/* Additional override for all number inputs */
.main-content input[type=number]::-webkit-inner-spin-button,
.main-content input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  display: none !important;
}

/* Resizable table columns */
th.resizable {
  position: relative;
}

th.resizable::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
}

th.resizable:hover::after {
  background: rgba(0, 102, 204, 0.3);
}

  padding: 10px 0;
  justify-content: center;
}

.btn-logout:hover {
  background: rgba(255, 255, 255, 0.2);
}

.main-content {
  margin-left: 70px;
  flex: 1 1;
  min-width: 0;
  padding: 32px;
  padding-bottom: 60px; /* Space for footer */
  position: relative;
  z-index: 1;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Keep wide data tables reachable on every input type. */
.sales-history-table-scroll {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: auto;
  scrollbar-color: #94a3b8 #e2e8f0;
}

.sales-history-table-scroll::-webkit-scrollbar {
  height: 12px;
}

.sales-history-table-scroll::-webkit-scrollbar-track {
  background: #e2e8f0;
}

.sales-history-table-scroll::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border: 3px solid #e2e8f0;
  border-radius: 9999px;
}

.sales-history-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}

/* Footer styles */
.page-footer {
  width: calc(100% - 70px);
  margin-left: 70px;
  background: linear-gradient(to right, #1e3a8a, #3b82f6);
  color: white;
  padding: 12px 20px;
  text-align: center;
  font-size: 11px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  position: fixed;
  bottom: 0;
  z-index: 999;
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  font-family: 'Space Grotesk', sans-serif;
}

.page-subtitle {
  color: #666;
  font-size: 15px;
}

/* Stats Cards */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 16px;
}

.stat-icon.blue { background: #eff6ff; color: #0066cc; }
.stat-icon.green { background: #f0fdf4; color: #16a34a; }
.stat-icon.purple { background: #faf5ff; color: #9333ea; }

.stat-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  font-family: 'Space Grotesk', sans-serif;
}

/* Content Card */
.content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.card-header {
  padding: 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.card-body {
  padding: 24px;
}

/* Buttons */
.btn-secondary {
  padding: 10px 20px;
  background: white;
  color: #0066cc;
  border: 2px solid #0066cc;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
}

.btn-secondary:hover {
  background: #0066cc;
  color: white;
}

.btn-success {
  padding: 10px 20px;
  background: #16a34a;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
}

.btn-success:hover {
  background: #15803d;
}

.btn-danger {
  padding: 8px 16px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-danger:hover {
  background: #b91c1c;
}

/* Table */
.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background: #f9fafb;
  padding: 16px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e5e7eb;
}

.data-table td {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  color: #1f2937;
}

.data-table tr:hover {
  background: #f9fafb;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.page-btn {
  padding: 8px 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
}

.page-btn:hover {
  background: #f9fafb;
  border-color: #0066cc;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: #666;
  font-size: 14px;
}

/* Search Bar */
.search-bar {
  position: relative;
  margin-bottom: 24px;
  z-index: 10;
}

.search-input {
  width: 100%;
  padding: 14px 48px 14px 48px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 4px rgba(0, 102, 204, 0.1);
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
}

/* Import Page */
.import-zone {
  border: 3px dashed #d1d5db;
  border-radius: 16px;
  padding: 48px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.import-zone:hover {
  border-color: #0066cc;
  background: #f0f7ff;
}

.import-icon {
  font-size: 64px;
  color: #9ca3af;
  margin-bottom: 16px;
}

.import-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.import-subtitle {
  color: #666;
  font-size: 14px;
}

.file-input {
  display: none;
}

/* Loading */
.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f0f0f0;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Success Message */
.success-message {
  background: #f0fdf4;
  border: 1px solid #86efac;
  color: #16a34a;
  padding: 16px;
  border-radius: 12px;
  margin-top: 24px;
  text-align: center;
  font-weight: 500;
}

/* Error Message */
.error-message {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #dc2626;
  padding: 16px;
  border-radius: 12px;
  margin-top: 16px;
  text-align: center;
  font-weight: 500;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  font-family: 'Space Grotesk', sans-serif;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #9ca3af;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-close:hover {
  background: #f3f4f6;
  color: #374151;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .sidebar {
    display: none;
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
/* Keyboard Shortcut Hints */
.shortcut-hint {
  margin-left: auto;
  font-size: 10px;
  padding: 2px 6px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: white;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.menu-subitem:hover .shortcut-hint {
  opacity: 1;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
}

kbd {
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  padding: 4px 8px;
  background: #2d3748;
  color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  font-weight: bold;
}

/* ==================== DASHBOARD PRINT STYLES ==================== */
/* One-Page Print Format for Dashboard */

@media print {
  /* CSS variable for sidebar display */
  :root {
    --sidebar-display: none !important;
  }
  
  /* Reset for print */
  * {
    print-color-adjust: exact !important;
    color-adjust: exact !important;
    box-sizing: border-box !important;
  }
  
  /* Page setup - Landscape A4 */
  @page {
    size: A4 landscape;
    margin: 5mm;
  }
  
  /* FORCE HIDE SIDEBAR - Multiple selectors */
  .sidebar {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    height: 0 !important;
    position: absolute !important;
    left: -9999px !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
  
  /* Additional sidebar hiding */
  aside,
  nav,
  [class*="sidebar"],
  [class*="Sidebar"],
  .print\\\\:hidden,
  button:not(.print-keep),
  .btn,
  input,
  select,
  textarea,
  .shortcut-hint,
  header:not(.print-header),
  footer:not(.print-footer),
  [class*="lucide-"],
  svg.lucide-moon,
  svg.lucide-sun,
  [data-testid*="sidebar"],
  .fixed.left-0,
  .w-64,
  .w-16,
  .bg-gray-900.text-white.h-screen {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    left: -9999px !important;
  }
  
  /* Force body and html to full width */
  html, body {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    font-size: 9px !important;
  }
  
  /* Reset main content for full width - no margin */
  .main-content,
  [class*="main-content"],
  .ml-64,
  .ml-16 {
    margin-left: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    position: relative !important;
    left: 0 !important;
  }
  
  .app-container,
  [class*="app-container"] {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  /* Dashboard container - Remove min height and padding */
  .min-h-screen,
  [class*="min-h-screen"] {
    min-height: auto !important;
    height: auto !important;
    padding: 2mm !important;
    margin: 0 !important;
    background: white !important;
  }
  
  /* PRINT HEADER - Show only during print */
  .print\\\\:block {
    display: block !important;
  }
  
  .hidden.print\\\\:block {
    display: block !important;
    visibility: visible !important;
  }
  
  /* KPI Cards - Very Compact 4-column Grid */
  .grid {
    display: grid !important;
    gap: 3px !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  
  .grid-cols-2,
  .sm\\\\:grid-cols-2 {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
  .grid-cols-4,
  .md\\\\:grid-cols-4,
  .lg\\\\:grid-cols-4 {
    grid-template-columns: repeat(4, 1fr) !important;
  }
  
  /* Gradient cards - Keep colors */
  [class*="bg-gradient-to-br"] {
    print-color-adjust: exact !important;
  }
  
  /* Card sizing - Ultra compact */
  .rounded-lg,
  .rounded-xl,
  .rounded-md {
    border-radius: 2px !important;
  }
  
  /* Ultra compact padding */
  .p-4 {
    padding: 3px !important;
  }
  
  .p-3 {
    padding: 2px !important;
  }
  
  .p-2 {
    padding: 1px !important;
  }
  
  .px-4, .py-4 {
    padding: 2px !important;
  }
  
  /* Ultra small text for print to fit on one page */
  .text-3xl {
    font-size: 12px !important;
    line-height: 1.1 !important;
  }
  
  .text-2xl {
    font-size: 11px !important;
    line-height: 1.1 !important;
  }
  
  .text-xl {
    font-size: 10px !important;
    line-height: 1.1 !important;
  }
  
  .text-lg {
    font-size: 9px !important;
    line-height: 1.1 !important;
  }
  
  .text-base {
    font-size: 8px !important;
    line-height: 1.1 !important;
  }
  
  .text-sm {
    font-size: 7px !important;
    line-height: 1.1 !important;
  }
  
  .text-xs {
    font-size: 6px !important;
    line-height: 1.1 !important;
  }
  
  /* Charts - Very Compact height */
  .recharts-wrapper {
    max-height: 80px !important;
    height: 80px !important;
  }
  
  .recharts-surface {
    max-height: 80px !important;
  }
  
  /* ResponsiveContainer height override */
  [style*="height: 200px"],
  [style*="height: 180px"],
  [style*="height: 160px"] {
    height: 80px !important;
    max-height: 80px !important;
  }
  
  /* Goal Progress - Very Compact */
  .w-32.h-32,
  [class*="w-32"][class*="h-32"] {
    width: 40px !important;
    height: 40px !important;
  }
  
  /* Remove all shadows */
  .shadow,
  .shadow-sm,
  .shadow-md,
  .shadow-lg,
  .shadow-xl,
  [class*="shadow"] {
    box-shadow: none !important;
  }
  
  /* Compact margins */
  .mb-4, .mb-6, .mb-8 {
    margin-bottom: 2px !important;
  }
  
  .mt-4, .mt-6, .mt-8 {
    margin-top: 2px !important;
  }
  
  .gap-2, .gap-3, .gap-4, .gap-6 {
    gap: 2px !important;
  }
  
  .space-y-4 > * + *,
  .space-y-6 > * + * {
    margin-top: 2px !important;
  }
  
  /* Ensure content fits on one page */
  .overflow-y-auto,
  .overflow-x-auto,
  .overflow-auto {
    overflow: visible !important;
    max-height: none !important;
  }
  
  /* No page breaks inside important sections */
  .page-break-avoid,
  [class*="Card"],
  .recharts-wrapper {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  
  /* Print footer styling */
  .print-footer,
  .print\\\\:block.print\\\\:mt-4 {
    position: relative !important;
    margin-top: 3px !important;
    padding-top: 2px !important;
    border-top: 1px solid #ddd !important;
    font-size: 6px !important;
  }
  
  /* Card header compacting */
  [class*="CardHeader"] {
    padding: 2px 3px !important;
  }
  
  [class*="CardContent"] {
    padding: 2px 3px !important;
  }
  
  [class*="CardTitle"] {
    font-size: 8px !important;
    margin: 0 !important;
  }
  
  /* Flex containers */
  .flex {
    gap: 2px !important;
  }
  
  /* Hide scrollbars */
  ::-webkit-scrollbar {
    display: none !important;
  }
  
  /* Force single page */
  .print-single-page {
    max-height: 100vh !important;
    overflow: hidden !important;
    page-break-after: avoid !important;
  }
}

/* ==================== DARK MODE ENHANCEMENTS ==================== */

/* Dark mode card backgrounds */
.dark-mode .bg-white {
  background-color: #1f2937 !important;
}

.dark-mode .text-gray-500 {
  color: #9ca3af !important;
}

.dark-mode .text-gray-600 {
  color: #d1d5db !important;
}

.dark-mode .border-gray-200 {
  border-color: #374151 !important;
}

/* Dark mode input fields */
.dark-mode input,
.dark-mode select {
  background-color: #374151 !important;
  border-color: #4b5563 !important;
  color: #f9fafb !important;
}

/* Dark mode dropdown */
.dark-mode .bg-gray-50 {
  background-color: #111827 !important;
}

/* Dark mode charts */
.dark-mode .recharts-cartesian-grid-horizontal line,
.dark-mode .recharts-cartesian-grid-vertical line {
  stroke: #374151 !important;
}

.dark-mode .recharts-text {
  fill: #9ca3af !important;
}



/* Hide sidebar and footer when WhatsApp widget is open on mobile */
body.whatsapp-widget-open .sidebar {
  display: none !important;
}

body.whatsapp-widget-open .main-content {
  margin-left: 0 !important;
}

/* Hide footer when widget is open */
body.whatsapp-widget-open .fixed.bottom-0 {
  display: none !important;
}

/* Ensure WhatsApp widget overlays everything on mobile */
@media (max-width: 768px) {
  body.whatsapp-widget-open [data-testid="whatsapp-widget-panel"] {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 999999 !important;
    border-radius: 0 !important;
    background: white !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qEAAqE;AACrE;;;EAGE,oCAAoC;AACtC;;AAEA,yCAAyC;AACzC;;;;;;;;;EASE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;EACb,oBAAoB,EAAE,qBAAqB;AAC7C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;AAEA,gDAAgD;AAChD;;EAEE,mCAAmC;EACnC,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8CAA8C;AAC9C;;EAEE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;EAEE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,oBAAoB,EAAE,qBAAqB;EAC3C,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA,qEAAqE;AACrE,wCAAwC;;AAExC;EACE,qCAAqC;EACrC;IACE,kCAAkC;EACpC;;EAEA,oBAAoB;EACpB;IAEE,oCAAoC;IACpC,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,wBAAwB;IACxB,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA,8BAA8B;EAC9B;;;;;;;;;;;;;;;;;;;;;IAqBE,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA,kDAAkD;EAClD;;;;IAIE,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;;IAEE,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,wDAAwD;EACxD;;IAEE,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA,0CAA0C;EAC1C;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;IACxB,mBAAmB;IACnB,mCAAmC;IACnC,8BAA8B;EAChC;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;;;IAGE,gDAAgD;EAClD;;EAEA,iCAAiC;EACjC;IAEE,oCAAoC;EACtC;;EAEA,gCAAgC;EAChC;;;IAGE,6BAA6B;EAC/B;;EAEA,0BAA0B;EAC1B;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,kDAAkD;EAClD;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,wCAAwC;EACxC;;;IAGE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,uBAAuB;EACvB;;;;;;IAME,2BAA2B;EAC7B;;EAEA,oBAAoB;EACpB;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA,oCAAoC;EACpC;;;IAGE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,6CAA6C;EAC7C;;;IAGE,mCAAmC;IACnC,8BAA8B;EAChC;;EAEA,yBAAyB;EACzB;;IAEE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,wBAAwB;EAC1B;;EAEA,sBAAsB;EACtB;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,kCAAkC;EACpC;AACF;;AAEA,qEAAqE;;AAErE,+BAA+B;AAC/B;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA,mEAAmE;AACnE;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Space+Grotesk:wght@500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8f0f7 100%);\n  min-height: 100vh;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* UNIVERSAL AUTO-CAPITALIZE - All text inputs convert to UPPERCASE */\ninput[type=\"text\"]:not(.no-uppercase):not([type=\"email\"]):not([type=\"url\"]),\ninput:not([type]):not(.no-uppercase),\ntextarea:not(.no-uppercase) {\n  text-transform: uppercase !important;\n}\n\n/* Exceptions - Do NOT capitalize these */\ninput[type=\"email\"],\ninput[type=\"url\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"search\"].no-uppercase,\ninput.no-uppercase,\ntextarea.no-uppercase {\n  text-transform: none !important;\n}\n\n/* Login Page */\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #0066cc 0%, #004d99 50%, #003366 100%);\n  padding: 20px;\n  padding-bottom: 60px; /* Space for footer */\n}\n\n.login-card {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(20px);\n  border-radius: 24px;\n  padding: 48px;\n  max-width: 440px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.login-logo {\n  width: 72px;\n  height: 72px;\n  background: linear-gradient(135deg, #0066cc, #0052a3);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n  font-size: 32px;\n  color: white;\n  font-weight: 700;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.login-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.login-subtitle {\n  color: #666;\n  font-size: 15px;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  font-family: 'Inter', sans-serif;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 4px rgba(0, 102, 204, 0.1);\n}\n\n.btn-primary {\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, #0066cc, #0052a3);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Inter', sans-serif;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 102, 204, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.otp-note {\n  margin-top: 16px;\n  padding: 12px;\n  background: #eff6ff;\n  border-left: 3px solid #0066cc;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #0066cc;\n}\n\n/* Dashboard Layout */\n.dashboard-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n.sidebar {\n  width: 70px;\n  background: linear-gradient(180deg, #0066cc 0%, #004d99 100%);\n  color: white;\n  padding: 16px 0;\n  padding-bottom: 100px;\n  position: fixed;\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  transition: width 0.3s ease;\n}\n\n.sidebar:hover {\n  width: 260px;\n}\n\n.sidebar-text {\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.sidebar:hover .sidebar-text {\n  opacity: 1;\n  width: auto;\n  min-width: max-content;\n}\n\n.sidebar-header {\n  padding: 0 0 16px 0;\n  margin-bottom: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sidebar:hover .sidebar-header {\n  padding: 0 20px 16px 20px;\n  justify-content: flex-start;\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 24px;\n  font-weight: 700;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.sidebar-logo-icon {\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar-menu {\n  padding: 12px 0;\n  margin-bottom: 80px;\n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  margin: 2px 0;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.sidebar:hover .menu-item {\n  justify-content: flex-start;\n  padding: 10px 20px;\n}\n\n.menu-item:hover,\n.menu-item.active {\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  border-left: 3px solid white;\n}\n\n/* Menu Groups */\n.menu-group {\n  margin-bottom: 4px;\n}\n\n.menu-group-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 14px;\n  margin: 2px 0;\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n  font-size: 14px;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.sidebar:hover .menu-group-header {\n  justify-content: flex-start;\n  padding: 8px 20px;\n}\n\n.menu-group-header:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.menu-group-items {\n  display: flex;\n  flex-direction: column;\n}\n\n.menu-subitem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  padding-left: 28px;\n  margin: 1px 0;\n  color: rgba(255, 255, 255, 0.75);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-weight: 400;\n  font-size: 13px;\n  justify-content: center;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.sidebar:hover .menu-subitem {\n  justify-content: flex-start;\n  padding-left: 44px;\n  padding-right: 20px;\n  overflow: visible;\n}\n\n.sidebar:hover .menu-subitem .sidebar-text {\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.menu-subitem:hover,\n.menu-subitem.active {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border-left: 3px solid rgba(255, 255, 255, 0.5);\n}\n\n.sidebar-footer {\n  position: fixed;\n  bottom: 0;\n  width: 70px;\n  padding: 12px 12px;\n  background: linear-gradient(180deg, #004d99 0%, #003366 100%);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  transition: width 0.3s ease;\n}\n\n.sidebar:hover .sidebar-footer {\n  width: 260px;\n  padding: 16px 20px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  justify-content: center;\n}\n\n.sidebar:hover .user-info {\n  justify-content: flex-start;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.user-details {\n  flex: 1;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.user-role {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: capitalize;\n}\n\n.btn-logout {\n  width: 100%;\n  padding: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar:not(:hover) .btn-logout {\n\n/* Remove number input arrows - Force override */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none !important;\n  margin: 0 !important;\n  display: none !important;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield !important;\n}\n\n/* Additional override for all number inputs */\n.main-content input[type=number]::-webkit-inner-spin-button,\n.main-content input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none !important;\n  display: none !important;\n}\n\n/* Resizable table columns */\nth.resizable {\n  position: relative;\n}\n\nth.resizable::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 4px;\n  height: 100%;\n  cursor: col-resize;\n  background: transparent;\n}\n\nth.resizable:hover::after {\n  background: rgba(0, 102, 204, 0.3);\n}\n\n  padding: 10px 0;\n  justify-content: center;\n}\n\n.btn-logout:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.main-content {\n  margin-left: 70px;\n  flex: 1;\n  min-width: 0;\n  padding: 32px;\n  padding-bottom: 60px; /* Space for footer */\n  position: relative;\n  z-index: 1;\n  transition: margin-left 0.3s ease;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Keep wide data tables reachable on every input type. */\n.sales-history-table-scroll {\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: auto;\n  scrollbar-color: #94a3b8 #e2e8f0;\n}\n\n.sales-history-table-scroll::-webkit-scrollbar {\n  height: 12px;\n}\n\n.sales-history-table-scroll::-webkit-scrollbar-track {\n  background: #e2e8f0;\n}\n\n.sales-history-table-scroll::-webkit-scrollbar-thumb {\n  background: #94a3b8;\n  border: 3px solid #e2e8f0;\n  border-radius: 9999px;\n}\n\n.sales-history-table-scroll::-webkit-scrollbar-thumb:hover {\n  background: #64748b;\n}\n\n/* Footer styles */\n.page-footer {\n  width: calc(100% - 70px);\n  margin-left: 70px;\n  background: linear-gradient(to right, #1e3a8a, #3b82f6);\n  color: white;\n  padding: 12px 20px;\n  text-align: center;\n  font-size: 11px;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  position: fixed;\n  bottom: 0;\n  z-index: 999;\n}\n\n.page-header {\n  margin-bottom: 32px;\n}\n\n.page-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.page-subtitle {\n  color: #666;\n  font-size: 15px;\n}\n\n/* Stats Cards */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin-bottom: 16px;\n}\n\n.stat-icon.blue { background: #eff6ff; color: #0066cc; }\n.stat-icon.green { background: #f0fdf4; color: #16a34a; }\n.stat-icon.purple { background: #faf5ff; color: #9333ea; }\n\n.stat-label {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a1a1a;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n/* Content Card */\n.content-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n.card-header {\n  padding: 24px;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.card-body {\n  padding: 24px;\n}\n\n/* Buttons */\n.btn-secondary {\n  padding: 10px 20px;\n  background: white;\n  color: #0066cc;\n  border: 2px solid #0066cc;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Inter', sans-serif;\n}\n\n.btn-secondary:hover {\n  background: #0066cc;\n  color: white;\n}\n\n.btn-success {\n  padding: 10px 20px;\n  background: #16a34a;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Inter', sans-serif;\n}\n\n.btn-success:hover {\n  background: #15803d;\n}\n\n.btn-danger {\n  padding: 8px 16px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.btn-danger:hover {\n  background: #b91c1c;\n}\n\n/* Table */\n.table-container {\n  overflow-x: auto;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table th {\n  background: #f9fafb;\n  padding: 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.data-table td {\n  padding: 16px;\n  border-bottom: 1px solid #f0f0f0;\n  color: #1f2937;\n}\n\n.data-table tr:hover {\n  background: #f9fafb;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.page-btn {\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n}\n\n.page-btn:hover {\n  background: #f9fafb;\n  border-color: #0066cc;\n}\n\n.page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-info {\n  color: #666;\n  font-size: 14px;\n}\n\n/* Search Bar */\n.search-bar {\n  position: relative;\n  margin-bottom: 24px;\n  z-index: 10;\n}\n\n.search-input {\n  width: 100%;\n  padding: 14px 48px 14px 48px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 4px rgba(0, 102, 204, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n}\n\n/* Import Page */\n.import-zone {\n  border: 3px dashed #d1d5db;\n  border-radius: 16px;\n  padding: 48px;\n  text-align: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.import-zone:hover {\n  border-color: #0066cc;\n  background: #f0f7ff;\n}\n\n.import-icon {\n  font-size: 64px;\n  color: #9ca3af;\n  margin-bottom: 16px;\n}\n\n.import-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.import-subtitle {\n  color: #666;\n  font-size: 14px;\n}\n\n.file-input {\n  display: none;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f0f0f0;\n  border-top-color: #0066cc;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Success Message */\n.success-message {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  color: #16a34a;\n  padding: 16px;\n  border-radius: 12px;\n  margin-top: 24px;\n  text-align: center;\n  font-weight: 500;\n}\n\n/* Error Message */\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #dc2626;\n  padding: 16px;\n  border-radius: 12px;\n  margin-top: 16px;\n  text-align: center;\n  font-weight: 500;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.modal-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1a1a1a;\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.btn-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #9ca3af;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.btn-close:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .sidebar {\n    display: none;\n  }\n  \n  .main-content {\n    margin-left: 0;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n/* Keyboard Shortcut Hints */\n.shortcut-hint {\n  margin-left: auto;\n  font-size: 10px;\n  padding: 2px 6px;\n  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);\n  color: white;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-weight: bold;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.menu-subitem:hover .shortcut-hint {\n  opacity: 1;\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n}\n\nkbd {\n  font-family: 'Courier New', monospace;\n  font-size: 0.9em;\n  padding: 4px 8px;\n  background: #2d3748;\n  color: white;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  font-weight: bold;\n}\n\n/* ==================== DASHBOARD PRINT STYLES ==================== */\n/* One-Page Print Format for Dashboard */\n\n@media print {\n  /* CSS variable for sidebar display */\n  :root {\n    --sidebar-display: none !important;\n  }\n  \n  /* Reset for print */\n  * {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    color-adjust: exact !important;\n    box-sizing: border-box !important;\n  }\n  \n  /* Page setup - Landscape A4 */\n  @page {\n    size: A4 landscape;\n    margin: 5mm;\n  }\n  \n  /* FORCE HIDE SIDEBAR - Multiple selectors */\n  .sidebar {\n    display: none !important;\n    visibility: hidden !important;\n    width: 0 !important;\n    height: 0 !important;\n    position: absolute !important;\n    left: -9999px !important;\n    opacity: 0 !important;\n    pointer-events: none !important;\n  }\n  \n  /* Additional sidebar hiding */\n  aside,\n  nav,\n  [class*=\"sidebar\"],\n  [class*=\"Sidebar\"],\n  .print\\\\:hidden,\n  button:not(.print-keep),\n  .btn,\n  input,\n  select,\n  textarea,\n  .shortcut-hint,\n  header:not(.print-header),\n  footer:not(.print-footer),\n  [class*=\"lucide-\"],\n  svg.lucide-moon,\n  svg.lucide-sun,\n  [data-testid*=\"sidebar\"],\n  .fixed.left-0,\n  .w-64,\n  .w-16,\n  .bg-gray-900.text-white.h-screen {\n    display: none !important;\n    visibility: hidden !important;\n    width: 0 !important;\n    height: 0 !important;\n    overflow: hidden !important;\n    position: absolute !important;\n    left: -9999px !important;\n  }\n  \n  /* Force body and html to full width */\n  html, body {\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white !important;\n    font-size: 9px !important;\n  }\n  \n  /* Reset main content for full width - no margin */\n  .main-content,\n  [class*=\"main-content\"],\n  .ml-64,\n  .ml-16 {\n    margin-left: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    position: relative !important;\n    left: 0 !important;\n  }\n  \n  .app-container,\n  [class*=\"app-container\"] {\n    display: block !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  \n  /* Dashboard container - Remove min height and padding */\n  .min-h-screen,\n  [class*=\"min-h-screen\"] {\n    min-height: auto !important;\n    height: auto !important;\n    padding: 2mm !important;\n    margin: 0 !important;\n    background: white !important;\n  }\n  \n  /* PRINT HEADER - Show only during print */\n  .print\\\\:block {\n    display: block !important;\n  }\n  \n  .hidden.print\\\\:block {\n    display: block !important;\n    visibility: visible !important;\n  }\n  \n  /* KPI Cards - Very Compact 4-column Grid */\n  .grid {\n    display: grid !important;\n    gap: 3px !important;\n    page-break-inside: avoid !important;\n    break-inside: avoid !important;\n  }\n  \n  .grid-cols-2,\n  .sm\\\\:grid-cols-2 {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n  \n  .grid-cols-4,\n  .md\\\\:grid-cols-4,\n  .lg\\\\:grid-cols-4 {\n    grid-template-columns: repeat(4, 1fr) !important;\n  }\n  \n  /* Gradient cards - Keep colors */\n  [class*=\"bg-gradient-to-br\"] {\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n  }\n  \n  /* Card sizing - Ultra compact */\n  .rounded-lg,\n  .rounded-xl,\n  .rounded-md {\n    border-radius: 2px !important;\n  }\n  \n  /* Ultra compact padding */\n  .p-4 {\n    padding: 3px !important;\n  }\n  \n  .p-3 {\n    padding: 2px !important;\n  }\n  \n  .p-2 {\n    padding: 1px !important;\n  }\n  \n  .px-4, .py-4 {\n    padding: 2px !important;\n  }\n  \n  /* Ultra small text for print to fit on one page */\n  .text-3xl {\n    font-size: 12px !important;\n    line-height: 1.1 !important;\n  }\n  \n  .text-2xl {\n    font-size: 11px !important;\n    line-height: 1.1 !important;\n  }\n  \n  .text-xl {\n    font-size: 10px !important;\n    line-height: 1.1 !important;\n  }\n  \n  .text-lg {\n    font-size: 9px !important;\n    line-height: 1.1 !important;\n  }\n  \n  .text-base {\n    font-size: 8px !important;\n    line-height: 1.1 !important;\n  }\n  \n  .text-sm {\n    font-size: 7px !important;\n    line-height: 1.1 !important;\n  }\n  \n  .text-xs {\n    font-size: 6px !important;\n    line-height: 1.1 !important;\n  }\n  \n  /* Charts - Very Compact height */\n  .recharts-wrapper {\n    max-height: 80px !important;\n    height: 80px !important;\n  }\n  \n  .recharts-surface {\n    max-height: 80px !important;\n  }\n  \n  /* ResponsiveContainer height override */\n  [style*=\"height: 200px\"],\n  [style*=\"height: 180px\"],\n  [style*=\"height: 160px\"] {\n    height: 80px !important;\n    max-height: 80px !important;\n  }\n  \n  /* Goal Progress - Very Compact */\n  .w-32.h-32,\n  [class*=\"w-32\"][class*=\"h-32\"] {\n    width: 40px !important;\n    height: 40px !important;\n  }\n  \n  /* Remove all shadows */\n  .shadow,\n  .shadow-sm,\n  .shadow-md,\n  .shadow-lg,\n  .shadow-xl,\n  [class*=\"shadow\"] {\n    box-shadow: none !important;\n  }\n  \n  /* Compact margins */\n  .mb-4, .mb-6, .mb-8 {\n    margin-bottom: 2px !important;\n  }\n  \n  .mt-4, .mt-6, .mt-8 {\n    margin-top: 2px !important;\n  }\n  \n  .gap-2, .gap-3, .gap-4, .gap-6 {\n    gap: 2px !important;\n  }\n  \n  .space-y-4 > * + *,\n  .space-y-6 > * + * {\n    margin-top: 2px !important;\n  }\n  \n  /* Ensure content fits on one page */\n  .overflow-y-auto,\n  .overflow-x-auto,\n  .overflow-auto {\n    overflow: visible !important;\n    max-height: none !important;\n  }\n  \n  /* No page breaks inside important sections */\n  .page-break-avoid,\n  [class*=\"Card\"],\n  .recharts-wrapper {\n    page-break-inside: avoid !important;\n    break-inside: avoid !important;\n  }\n  \n  /* Print footer styling */\n  .print-footer,\n  .print\\\\:block.print\\\\:mt-4 {\n    position: relative !important;\n    margin-top: 3px !important;\n    padding-top: 2px !important;\n    border-top: 1px solid #ddd !important;\n    font-size: 6px !important;\n  }\n  \n  /* Card header compacting */\n  [class*=\"CardHeader\"] {\n    padding: 2px 3px !important;\n  }\n  \n  [class*=\"CardContent\"] {\n    padding: 2px 3px !important;\n  }\n  \n  [class*=\"CardTitle\"] {\n    font-size: 8px !important;\n    margin: 0 !important;\n  }\n  \n  /* Flex containers */\n  .flex {\n    gap: 2px !important;\n  }\n  \n  /* Hide scrollbars */\n  ::-webkit-scrollbar {\n    display: none !important;\n  }\n  \n  /* Force single page */\n  .print-single-page {\n    max-height: 100vh !important;\n    overflow: hidden !important;\n    page-break-after: avoid !important;\n  }\n}\n\n/* ==================== DARK MODE ENHANCEMENTS ==================== */\n\n/* Dark mode card backgrounds */\n.dark-mode .bg-white {\n  background-color: #1f2937 !important;\n}\n\n.dark-mode .text-gray-500 {\n  color: #9ca3af !important;\n}\n\n.dark-mode .text-gray-600 {\n  color: #d1d5db !important;\n}\n\n.dark-mode .border-gray-200 {\n  border-color: #374151 !important;\n}\n\n/* Dark mode input fields */\n.dark-mode input,\n.dark-mode select {\n  background-color: #374151 !important;\n  border-color: #4b5563 !important;\n  color: #f9fafb !important;\n}\n\n/* Dark mode dropdown */\n.dark-mode .bg-gray-50 {\n  background-color: #111827 !important;\n}\n\n/* Dark mode charts */\n.dark-mode .recharts-cartesian-grid-horizontal line,\n.dark-mode .recharts-cartesian-grid-vertical line {\n  stroke: #374151 !important;\n}\n\n.dark-mode .recharts-text {\n  fill: #9ca3af !important;\n}\n\n\n\n/* Hide sidebar and footer when WhatsApp widget is open on mobile */\nbody.whatsapp-widget-open .sidebar {\n  display: none !important;\n}\n\nbody.whatsapp-widget-open .main-content {\n  margin-left: 0 !important;\n}\n\n/* Hide footer when widget is open */\nbody.whatsapp-widget-open .fixed.bottom-0 {\n  display: none !important;\n}\n\n/* Ensure WhatsApp widget overlays everything on mobile */\n@media (max-width: 768px) {\n  body.whatsapp-widget-open [data-testid=\"whatsapp-widget-panel\"] {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    z-index: 999999 !important;\n    border-radius: 0 !important;\n    background: white !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
